import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie';
import { debounceTime, distinctUntilChanged, startWith, Subscription } from 'rxjs';
import { GenericApiService } from '../../../core/generic-api.service';
import { toastrConfig } from 'projects/is-ui-kit/src/lib/core/configs';
import { ActionToastComponent } from 'projects/is-ui-kit/src/lib/core/utils-initializer/utils/custom-notifiers/action-toast/action-toast.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent {

  public showSpinner = false;

  public typingPassword: boolean = false;
  public showPassword: boolean = false;
  public passwordSub$: Subscription;
  public customerList: any[] = [];
  public customerNgx = new FormControl();
  public customerSubscription: Subscription;
  private _timeout: any;


  public passwordMatchValidator: ValidatorFn = (formGroup: AbstractControl): ValidationErrors | null => {
    const password = formGroup.get('password')?.value;
    const confirmPassword = formGroup.get('confirm_password')?.value;

    return password && confirmPassword && password !== confirmPassword ? { passwordMismatch: true } : null;
  };

  public createUserForm: FormGroup = new FormGroup({
    first_name: new FormControl(null, [Validators.required]),
    last_name: new FormControl(null, [Validators.required]),
    username: new FormControl(null, [Validators.required]),
    company: new FormControl(null, [Validators.required]),
    email: new FormControl(null, [Validators.required, Validators.email]),
    password: new FormControl(null, [Validators.required]),
    confirm_password: new FormControl(null, [Validators.required])
  }, { validators: this.passwordMatchValidator });


  constructor(private _http: HttpClient,
    private _router: Router,
    private _toastr: ToastrService,
    private _cookieService: CookieService,
    private _cd: ChangeDetectorRef,
    private _apiService: GenericApiService,
    private _translate: TranslateService
  ) { }

  public changeShowPassword(): void {
    this.showPassword = !this.showPassword;
    this._cd.detectChanges();
  }


  ngOnInit(): void {
    // check typing password for show view button
    this.passwordSub$ = this.createUserForm.get('password').valueChanges.subscribe((value) => {
      if (value && value !== '') {
        this.typingPassword = true;
      } else {
        this.typingPassword = false;
      }
    });

    this.customerNgx.setValue('');
    this.getCustomers();
  }

  public goToLogin(): void {
    this._router.navigate(['/']);
  }

  public getCustomers(queryParams: any = null): void {
    this._apiService.getCustomersCodePublic((error: Error, data: any) => {
      if (error) {
        console.log(error);
      } else if (data) {
        this.customerList = data;
      }
    }, queryParams);
  }
  public subscribeCompany(): void {
    this.customerSubscription = this.customerNgx.valueChanges.pipe(
      startWith(this.customerNgx.value),
      debounceTime(300),
      distinctUntilChanged()
    )
      .subscribe((value) => {
        this.getCustomerFilter(value);
      });
  }

  public getCustomerFilter(val): void {
    clearTimeout(this._timeout);
    this._timeout = setTimeout(() => {
      if (val && val !== '') {
        let queryParams = '';
        queryParams = `?search=${val}`;
        this.getCustomers(queryParams);
      } else {
        let queryParams = '';
        queryParams = ``;
        this.getCustomers(queryParams);
      }
    }, 500);
  }

  public selectCustomers(): void {
    if (this.customerSubscription && !this.customerSubscription?.closed) {
      this.customerSubscription.unsubscribe();
    }
  }

  public createUser(): void {
    const obj = {
      username: this.createUserForm.get('username').value,
      password: this.createUserForm.get('password').value,
      password_confirm: this.createUserForm.get('confirm_password').value,
      email: this.createUserForm.get('email').value,
      first_name: this.createUserForm.get('first_name').value,
      last_name: this.createUserForm.get('last_name').value,
      company: this.createUserForm.get('company').value,
    };
    this._apiService.createUser((error: HttpErrorResponse, response: any) => {
      if (error) {
        const passwordError = error?.error?.password?.[0];
        const emailError = error?.error?.email?.[0];
        const passwordConfirm = error?.error?.password_confirm?.[0];

        const textToastr = this._translate.instant(passwordError || emailError || passwordConfirm || 'generic_error');
        this.showCustomToast({
          type: 'error',
          info: textToastr
        });

      } else {
        const textToastr = this._translate.instant('user_created_successfully', { username: response?.user?.username });
        this._router.navigate(['/']);
        this.showCustomToast({
          type: 'success',
          info: textToastr
        });

      }
    }, obj);
  }


  public showCustomToast(options: {
    type: 'error' | 'success' | 'warning' | 'info';
    info: string;
    buttonText?: string;
  }): ActiveToast<any> {
    const activeToast = this._toastr[options.type](
      (options.info),
      null,
      {
        ...toastrConfig,
        ...{
          timeOut: 7000,
          closeButton: true,
          toastComponent: ActionToastComponent,
          tapToDismiss: false
        }
      }
    );
    activeToast.toastRef.componentInstance.buttonText = options?.buttonText;
    return activeToast;
  }


}